import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteCustomFieldValue($companyId: ID!, $id: ID!) {
    deleteCustomFieldValue(companyId: $companyId, id: $id) {
       customFieldValue {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
